import React from "react";
import { merge } from "glamor";
import theme from "styles/theme";

export default function Bottom({ style = {} }) {
    return (
        <div
            {...merge(
                {
                    height: "20px",
                    borderBottom: `1px solid ${theme.palette.borderColor}`,
                    margin: "0 9px 0 8px",
                },
                style
            )}
        />
    );
}
